import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=4e885e6a&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"
import style0 from "./Orders.vue?vue&type=style&index=0&id=4e885e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e885e6a",
  null
  
)

export default component.exports